import type { UsagePage } from '../shared/billing';

type BillingPageProps = {
  page?: UsagePage;
  loading: boolean;
  loadingMore?: boolean;
  error: string;
  onBack: () => void;
  onLoadMore: () => void;
};

const FEATURE_NAMES = {
  text: '小说生成',
  image: '配图',
  audio: '配音',
  video: '视频',
} as const;

function formatDate(value: string) {
  return new Intl.DateTimeFormat('zh-CN', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
}

export function BillingPage({ page, loading, loadingMore = false, error, onBack, onLoadMore }: BillingPageProps) {
  return <section className="billing-page">
    <button className="billing-back" type="button" onClick={onBack}>← 返回</button>
    <header className="billing-heading">
      <span className="section-kicker">个人账单</span>
      <h1>消费记录</h1>
      <p>成功生成后按后台配置售价从余额扣除</p>
    </header>

    <div className="billing-balance">
      <span>当前余额</span>
      <strong>{page?.balanceText ?? '¥0.00'}</strong>
    </div>
    <div className="billing-month">
      <span>本月展示金额</span>
      <strong>{page?.monthSellingText ?? '¥0.00'}</strong>
    </div>

    {error && <div className="billing-state" role="alert">{error}</div>}
    {loading && !page && <div className="billing-state" role="status">正在读取消费记录…</div>}
    {!loading && !error && page?.items.length === 0 && <div className="billing-state">还没有消费记录。</div>}

    {page && page.items.length > 0 && <div className="billing-list">
      {page.items.map((item) => <article className="billing-row" key={item.id}>
        <div>
          <strong>{FEATURE_NAMES[item.feature]}</strong>
          <span>{item.projectTitle ?? '未关联小说'}{item.sceneIndex ? ` · 第 ${String(item.sceneIndex).padStart(2, '0')} 幕` : ''}</span>
          <small>{formatDate(item.createdAt)} · {item.quantityLabel}</small>
        </div>
        <div className="billing-row-price">
          <strong>{item.sellingPriceText}</strong>
        </div>
      </article>)}
    </div>}

    {page?.nextCursor && <button className="billing-more" disabled={loadingMore} type="button" onClick={onLoadMore}>
      {loadingMore ? '正在加载…' : '查看更多'}
    </button>}
  </section>;
}
